export default __webpack_public_path__ + "static/media/10.6.9cae842b.jpg";